import { unwrapAGraphResponse } from '../../../utils/AGraphWrapper';
import { conditionalParam } from '../AGraphUtils';
import { awBridgeApi } from '../Base';
import { AlertStatusUpdatedData, AWEventData, ReleaseOrdersPayload } from '../Models';
import { EventTypes } from './Constants';

const path = '/v1/events';

export async function postAwEvent({
  data,
  pkg,
  type,
}: {
  data: AWEventData | ReleaseOrdersPayload | AlertStatusUpdatedData;
  pkg: string;
  type: EventTypes;
}) {
  try {
    const response = await awBridgeApi.post(
      path,
      {
        type,
        pkg,
        source: window.location.href,
        data,
      },
      { params: { pkg: conditionalParam(path, 'pkg', pkg) } }
    );
    return unwrapAGraphResponse(response, 'event');
  } catch (error) {
    return { error };
  }
}
